import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import BackButton from '../../Shared/BackButton'
import { FaFileExport } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const LocationBalanceDetail = () => {
    const [data, setData] = useState([])
    const [pinnedBottomRowData, setPinnedBottomRowData] = useState([])
    const [title, setTitle] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const gridRef = useRef();
    const navigate = useNavigate()
    const location = useLocation()

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post(`/location-balance/${payload.by}?public_id=${payload.public_id}&status=${payload.status}`)
            
            setData(response?.data)
            setIsLoading(false) 

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                data.credit += parseFloat(row.credit);
                return data;
            }, {debit: 0.00, credit: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    debit: parseFloat(output.debit).toFixed(2),
                    credit: parseFloat(output.credit).toFixed(2),
                    balance: (output.debit - output.credit).toFixed(2)
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail)
            }
        }
    }

    useEffect(() => {
        
        if (location.state){
            const { data } = location.state
            setTitle(`${data.name} Location Balance Details`)
            fetchData({public_id: data.public_id, status: data.status, by: data.by})
        }
        
    }, [])

    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        
        {
            headerName: "ID",
            field: "location_id",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Name",
            field: "full_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: true,
        },
    ]);

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
    
    const onExportClick=() => {
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-6">
                <BackButton
                    to="/location-balance"
                    state={{ status: location.state?.data?.status, by: location.state?.data?.by }}
                    label="Back to Summary"
                />
            </div>
            <div className="col-md-6">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                            onGridReady={onGridReady}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default LocationBalanceDetail